/**
 * @generated SignedSource<<d19e5af5dd61f21497c5fb95cbaa90c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSummaryCell179BadPattern$data = {
  readonly __id: string;
  readonly key: string;
  readonly " $fragmentType": "IssueSummaryCell179BadPattern";
};
export type IssueSummaryCell179BadPattern$key = {
  readonly " $data"?: IssueSummaryCell179BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSummaryCell179BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueSummaryCell179BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "b982b08a5176b1cb137c4716345f554e";

export default node;
